import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Collapse, Dropdown } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import { canAccessModule, getLoggedUser, normalizeRole, roleLabel, isCarwashOnly } from '../utils/accessControl';

class Sidebar extends Component {

  state = {};

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({[menuState] : false});
    } else if(Object.keys(this.state).length === 0) {
      this.setState({[menuState] : true});
    } else {
      Object.keys(this.state).forEach(i => {
        this.setState({[i]: false});
      });
      this.setState({[menuState] : true}); 
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active');
    Object.keys(this.state).forEach(i => {
      this.setState({[i]: false});
    });

    const dropdownPaths = [
      {path:'/inventory', state: 'inventoryMenuOpen'},
      {path:'/einvoice', state: 'einvoiceMenuOpen'},
      {path:'/carwash', state: 'carwashMenuOpen'},
      {path:'/user-pages', state: 'userPagesMenuOpen'},
      {path:'/error-pages', state: 'errorPagesMenuOpen'},
    ];

    dropdownPaths.forEach((obj => {
      if (this.isPathActive(obj.path)) {
        this.setState({[obj.state] : true})
      }
    }));
 
  }

  render () {
    const loggedUser = getLoggedUser();
    const displayName = loggedUser?.full_name || loggedUser?.username || 'Usuario';
    const displayRole = roleLabel(loggedUser?.role) || 'Miembro';
    const carwashOnly = isCarwashOnly(loggedUser);
    const brandName = carwashOnly ? 'Carwash' : 'J&M Import';
    const brandMini = carwashOnly ? 'CW' : 'AR';
    const canInventoryProducts = canAccessModule('inventory', 'products', loggedUser);
    const canInventorySuppliers = canAccessModule('inventory', 'suppliers', loggedUser);
    const canInventoryKardex = canAccessModule('inventory', 'kardex-movements', loggedUser);
    const canInventoryDocuments = canAccessModule('inventory', 'document-register', loggedUser);
    const canInventoryTapers = canAccessModule('inventory', 'tapers', loggedUser);
    const canInventoryTransfers = canAccessModule('inventory', 'transfers', loggedUser);
    const canInventoryPhonePurchases = canAccessModule('inventory', 'phone-purchases', loggedUser);
    const canSeeInventory = canInventoryProducts || canInventorySuppliers || canInventoryKardex
      || canInventoryDocuments || canInventoryTapers || canInventoryPhonePurchases || canInventoryTransfers;
    const canEinvoiceInvoices = canAccessModule('einvoice', 'invoices', loggedUser);
    const canEinvoiceQuotations = canAccessModule('einvoice', 'quotations', loggedUser);
    const canEinvoiceGuides = canAccessModule('einvoice', 'guides', loggedUser);
    const canEinvoiceNotes = canAccessModule('einvoice', 'notes', loggedUser);
    const canEinvoiceServices = canAccessModule('einvoice', 'services', loggedUser);
    const canSeeEinvoice = canEinvoiceInvoices || canEinvoiceQuotations || canEinvoiceGuides || canEinvoiceNotes || canEinvoiceServices;
    const canCarwashDashboard = canAccessModule('carwash', 'dashboard', loggedUser);
    const canCarwashPos = canAccessModule('carwash', 'pos', loggedUser);
    const canCarwashOrders = canAccessModule('carwash', 'orders', loggedUser);
    const canCarwashServices = canAccessModule('carwash', 'services', loggedUser);
    const canCarwashEmployees = canAccessModule('carwash', 'employees', loggedUser);
    const canSeeCarwash = canCarwashDashboard || canCarwashPos || canCarwashOrders || canCarwashServices || canCarwashEmployees;
    const canManageUsers = canAccessModule('users', 'users', loggedUser);
    const canSeeSystemPages = normalizeRole(loggedUser?.role) === 'SUPER_ADMIN';

    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
          <a className="sidebar-brand brand-logo" href="index.html">
            <span
              style={{
                color: '#ff2d2d',
                fontWeight: 800,
                fontSize: '1.8rem',
                letterSpacing: '1px',
                textShadow: '-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff'
              }}
            >
              {brandName}
            </span>
          </a>
          <a className="sidebar-brand brand-logo-mini" href="index.html">
            <span
              style={{
                color: '#ff2d2d',
                fontWeight: 800,
                fontSize: '1rem',
                letterSpacing: '0.5px',
                textShadow: '-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff'
              }}
            >
              {brandMini}
            </span>
          </a>
        </div>
        <ul className="nav">
          <li className="nav-item profile">
            <div className="profile-desc">
              <div className="profile-pic">
                <div className="count-indicator">
                  <img className="img-xs rounded-circle " src={require('../../assets/images/faces/face15.jpg')} alt="profile" />
                  <span className="count bg-success"></span>
                </div>
                <div className="profile-name">
                  <h5 className="mb-0 font-weight-normal">{displayName}</h5>
                  <span>{displayRole}</span>
                </div>
              </div>
              <Dropdown alignRight>
                <Dropdown.Toggle as="a" className="cursor-pointer no-caret">
                  <i className="mdi mdi-dots-vertical"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu className="sidebar-dropdown preview-list">
                  <a href="!#" className="dropdown-item preview-item" onClick={evt =>evt.preventDefault()}>
                    <div className="preview-thumbnail">
                      <div className="preview-icon bg-dark rounded-circle">
                        <i className="mdi mdi-settings text-primary"></i>
                      </div>
                    </div>
                    <div className="preview-item-content">
                      <p className="preview-subject ellipsis mb-1 text-small"><Trans>Account settings</Trans></p>
                    </div>
                  </a>
                  <div className="dropdown-divider"></div>
                  <a href="!#" className="dropdown-item preview-item" onClick={evt =>evt.preventDefault()}>
                    <div className="preview-thumbnail">
                      <div className="preview-icon bg-dark rounded-circle">
                        <i className="mdi mdi-onepassword  text-info"></i>
                      </div>
                    </div>
                    <div className="preview-item-content">
                      <p className="preview-subject ellipsis mb-1 text-small"><Trans>Change Password</Trans></p>
                    </div>
                  </a>
                  <div className="dropdown-divider"></div>
                  <a href="!#" className="dropdown-item preview-item" onClick={evt =>evt.preventDefault()}>
                    <div className="preview-thumbnail">
                      <div className="preview-icon bg-dark rounded-circle">
                        <i className="mdi mdi-calendar-today text-success"></i>
                      </div>
                    </div>
                    <div className="preview-item-content">
                      <p className="preview-subject ellipsis mb-1 text-small"><Trans>To-do list</Trans></p>
                    </div>
                  </a>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </li>
          <li className="nav-item nav-category">
            <span className="nav-link"><Trans>Navigation</Trans></span>
          </li>
          <li className={ this.isPathActive('/dashboard') ? 'nav-item menu-items active' : 'nav-item menu-items' }>
            <Link className="nav-link" to="/dashboard">
              <span className="menu-icon"><i className="mdi mdi-speedometer"></i></span>
              <span className="menu-title"><Trans>Dashboard</Trans></span>
            </Link>
          </li>
          {canSeeInventory && (
          <li className={ this.isPathActive('/inventory') ? 'nav-item menu-items active' : 'nav-item menu-items' }>
            <div className={ this.state.inventoryMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('inventoryMenuOpen') } data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-package-variant"></i>
              </span>
              <span className="menu-title"><Trans>Inventario / Kardex</Trans></span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={ this.state.inventoryMenuOpen }>
              <div>
                <ul className="nav flex-column sub-menu">
                  {canInventoryProducts && <li className="nav-item"> <Link className={ this.isPathActive('/inventory/products') ? 'nav-link active' : 'nav-link' } to="/inventory/products"><Trans>Productos</Trans></Link></li>}
                  {canInventorySuppliers && <li className="nav-item"> <Link className={ this.isPathActive('/inventory/suppliers') ? 'nav-link active' : 'nav-link' } to="/inventory/suppliers"><Trans>Proveedores</Trans></Link></li>}
                  {canInventoryKardex && <li className="nav-item"> <Link className={ this.isPathActive('/inventory/kardex-movements') ? 'nav-link active' : 'nav-link' } to="/inventory/kardex-movements"><Trans>Movimientos Kardex</Trans></Link></li>}
                  {canInventoryDocuments && <li className="nav-item"> <Link className={ this.isPathActive('/inventory/document-register') ? 'nav-link active' : 'nav-link' } to="/inventory/document-register"><Trans>Registrar Documento</Trans></Link></li>}
                  {canInventoryTapers && <li className="nav-item"> <Link className={ this.isPathActive('/inventory/tapers') ? 'nav-link active' : 'nav-link' } to="/inventory/tapers">Taper&apos;s (stock interno)</Link></li>}
                  {canInventoryTransfers && <li className="nav-item"> <Link className={ this.isPathActive('/inventory/transfers') ? 'nav-link active' : 'nav-link' } to="/inventory/transfers">Transferencias entre tiendas</Link></li>}
                  {canInventoryPhonePurchases && <li className="nav-item"> <Link className={ this.isPathActive('/inventory/phone-purchases') ? 'nav-link active' : 'nav-link' } to="/inventory/phone-purchases">Celulares comprados / despiece</Link></li>}
                </ul>
              </div>
            </Collapse>
          </li>
          )}
          {canSeeEinvoice && (
          <li className={ this.isPathActive('/einvoice') ? 'nav-item menu-items active' : 'nav-item menu-items' }>
            <div className={ this.state.einvoiceMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('einvoiceMenuOpen') } data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-file-document-box-multiple"></i>
              </span>
              <span className="menu-title"><Trans>Comprobantes Electrónicos</Trans></span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={ this.state.einvoiceMenuOpen }>
              <div>
                <ul className="nav flex-column sub-menu">
                  {canEinvoiceInvoices && <li className="nav-item"> <Link className={ this.isPathActive('/einvoice/invoices') ? 'nav-link active' : 'nav-link' } to="/einvoice/invoices"><Trans>Factura Electrónica</Trans></Link></li>}
                  {canEinvoiceQuotations && <li className="nav-item"> <Link className={ this.isPathActive('/einvoice/quotations') ? 'nav-link active' : 'nav-link' } to="/einvoice/quotations"><Trans>Cotizaciones</Trans></Link></li>}
                  {canEinvoiceGuides && <li className="nav-item"> <Link className={ this.isPathActive('/einvoice/guides') ? 'nav-link active' : 'nav-link' } to="/einvoice/guides"><Trans>Guías</Trans></Link></li>}
                  {canEinvoiceNotes && <li className="nav-item"> <Link className={ this.isPathActive('/einvoice/notes') ? 'nav-link active' : 'nav-link' } to="/einvoice/notes"><Trans>Notas</Trans></Link></li>}
                  {canEinvoiceServices && <li className="nav-item"> <Link className={ this.isPathActive('/einvoice/services') ? 'nav-link active' : 'nav-link' } to="/einvoice/services"><Trans>Servicios internos</Trans></Link></li>}
                </ul>
              </div>
            </Collapse>
          </li>
          )}
          {canSeeCarwash && (
          <li className={ this.isPathActive('/carwash') ? 'nav-item menu-items active' : 'nav-item menu-items' }>
            <div className={ this.state.carwashMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('carwashMenuOpen') } data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-car"></i>
              </span>
              <span className="menu-title">Carwash</span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={ this.state.carwashMenuOpen }>
              <div>
                <ul className="nav flex-column sub-menu">
                  {canCarwashDashboard && <li className="nav-item"> <Link className={ this.isPathActive('/carwash') && !this.isPathActive('/carwash/') ? 'nav-link active' : (this.props.location.pathname === '/carwash' ? 'nav-link active' : 'nav-link') } to="/carwash">Dashboard</Link></li>}
                  {canCarwashPos && <li className="nav-item"> <Link className={ this.isCarwashTipo('TICKET') ? 'nav-link active' : 'nav-link' } to="/carwash/nuevo?tipo=TICKET">Ticket K003</Link></li>}
                  {canCarwashPos && <li className="nav-item"> <Link className={ this.isCarwashTipo('BOLETA') ? 'nav-link active' : 'nav-link' } to="/carwash/nuevo?tipo=BOLETA">Boleta B003</Link></li>}
                  {canCarwashPos && <li className="nav-item"> <Link className={ this.isCarwashTipo('FACTURA') ? 'nav-link active' : 'nav-link' } to="/carwash/nuevo?tipo=FACTURA">Factura F003</Link></li>}
                  {canCarwashOrders && <li className="nav-item"> <Link className={ this.isPathActive('/carwash/ordenes') ? 'nav-link active' : 'nav-link' } to="/carwash/ordenes">Órdenes</Link></li>}
                  {canCarwashServices && <li className="nav-item"> <Link className={ this.isPathActive('/carwash/servicios') ? 'nav-link active' : 'nav-link' } to="/carwash/servicios">Servicios y precios</Link></li>}
                  {canCarwashEmployees && <li className="nav-item"> <Link className={ this.isPathActive('/carwash/empleados') ? 'nav-link active' : 'nav-link' } to="/carwash/empleados">Empleados</Link></li>}
                </ul>
              </div>
            </Collapse>
          </li>
          )}
          {canManageUsers && (
          <li className={ this.isPathActive('/user-pages') ? 'nav-item menu-items active' : 'nav-item menu-items' }>
            <div className={ this.state.userPagesMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('userPagesMenuOpen') } data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-security"></i>
              </span>
              <span className="menu-title"><Trans>User Pages</Trans></span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={ this.state.userPagesMenuOpen }>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={ this.isPathActive('/user-pages/login-1') ? 'nav-link active' : 'nav-link' } to="/user-pages/login-1"><Trans>Login</Trans></Link></li>
                  <li className="nav-item"> <Link className={ this.isPathActive('/user-pages/register-1') ? 'nav-link active' : 'nav-link' } to="/user-pages/register-1"><Trans>Register</Trans></Link></li>
                  <li className="nav-item"> <Link className={ this.isPathActive('/user-pages/users') ? 'nav-link active' : 'nav-link' } to="/user-pages/users"><Trans>Usuarios</Trans></Link></li>
                </ul>
              </div>
            </Collapse>
          </li>
          )}
          {canSeeSystemPages && (
          <li className="nav-item nav-category">
            <span className="nav-link"><Trans>More</Trans></span>
          </li>
          )}
          {canSeeSystemPages && (
          <li className={ this.isPathActive('/error-pages') ? 'nav-item menu-items active' : 'nav-item menu-items' }>
            <div className={ this.state.errorPagesMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('errorPagesMenuOpen') } data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-lock"></i>
              </span>
              <span className="menu-title"><Trans>Error Pages</Trans></span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={ this.state.errorPagesMenuOpen }>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={ this.isPathActive('/error-pages/error-404') ? 'nav-link active' : 'nav-link' } to="/error-pages/error-404">404</Link></li>
                  <li className="nav-item"> <Link className={ this.isPathActive('/error-pages/error-500') ? 'nav-link active' : 'nav-link' } to="/error-pages/error-500">500</Link></li>
                </ul>
              </div>
            </Collapse>
          </li>
          )}
        </ul>
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  isCarwashTipo(tipo) {
    if (!this.isPathActive('/carwash/nuevo')) return false;
    const current = String(new URLSearchParams(this.props.location.search || '').get('tipo') || 'TICKET').toUpperCase();
    return current === String(tipo).toUpperCase();
  }

  componentDidMount() {
    this.onRouteChanged();
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector('body');
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      
      el.addEventListener('mouseover', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }

}

export default withRouter(Sidebar);